var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taption-terms",attrs:{"name":"termly-embed","data-id":"64d082f9-4de8-42f5-8dee-84328191e63f","data-type":"iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }